import { Link } from 'react-router-dom';
import { Rss } from 'lucide-react';

const DIAMOND_LOGO = "https://static.prod-images.emergentagent.com/jobs/842fdc3c-a0c8-43ee-a566-98abe6f2060f/images/bd677802dac45f2a8aaa59f7d977b4488ca07f740dc1f67c76ced84b505423af.png";

const Footer = () => {
  const yr = new Date().getFullYear();
  return (
    <footer className="bg-bb-rich border-t border-bb-border" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-14">
          <div className="md:col-span-2">
            <span className="font-heading text-3xl tracking-[0.3em] c-cream block mb-6">BEE BOOSTED</span>
            <p className="t-body c-muted max-w-sm mb-6 text-sm">
              Premium bee pollen, royal jelly, raw honeycomb, propolis tincture, and wildflower honey 
              sourced from family-owned apiaries in California and Arizona. Serving customers across 
              the Southwest and West Coast.
            </p>
            <div className="flex gap-6">
              <a href="/api/rss/blog" target="_blank" rel="noopener noreferrer" className="t-label c-muted hover:c-gold transition-colors flex items-center gap-2" data-testid="footer-rss-blog">
                <Rss className="w-3 h-3" /> Journal
              </a>
              <a href="/api/rss/products" target="_blank" rel="noopener noreferrer" className="t-label c-muted hover:c-gold transition-colors flex items-center gap-2" data-testid="footer-rss-products">
                <Rss className="w-3 h-3" /> Products
              </a>
            </div>
          </div>
          <div>
            <h4 className="t-label c-gold mb-6">Navigate</h4>
            <ul className="space-y-3">
              {[
                { to: '/products', label: 'Shop' },
                { to: '/blog', label: 'Journal' },
                { to: '/about', label: 'About' },
                { to: '/cart', label: 'Shopping Bag' },
              ].map((l) => (
                <li key={l.to}><Link to={l.to} className="t-body text-sm c-muted hover:c-cream transition-colors">{l.label}</Link></li>
              ))}
              <li><a href="https://gemstoneminerals.com/" target="_blank" rel="noopener noreferrer" className="t-body text-sm c-muted hover:c-cream transition-colors" data-testid="footer-gemstone">Gemstone Minerals</a></li>
            </ul>
          </div>
          <div>
            <h4 className="t-label c-gold mb-6">Collection</h4>
            <ul className="space-y-3">
              {[
                { slug: 'premium-bee-pollen', name: 'Bee Pollen' },
                { slug: 'pure-royal-jelly', name: 'Royal Jelly' },
                { slug: 'raw-honeycomb', name: 'Honeycomb' },
                { slug: 'propolis-tincture', name: 'Propolis Tincture' },
                { slug: 'wildflower-honey', name: 'Wildflower Honey' },
              ].map((p) => (
                <li key={p.slug}><Link to={`/products/${p.slug}`} className="t-body text-sm c-muted hover:c-cream transition-colors">{p.name}</Link></li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-bb-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex items-center justify-between">
          <p className="t-label c-muted text-[10px]">&copy; {yr} Bee Boosted. All rights reserved.</p>
          <a 
            href="https://kholey.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="opacity-30 hover:opacity-50 transition-opacity"
            data-testid="footer-kholey-logo"
          >
            <img 
              src={DIAMOND_LOGO} 
              alt="" 
              className="w-4 h-4 object-contain" 
              style={{ filter: 'brightness(0.5) sepia(1) hue-rotate(5deg) saturate(0.3)' }}
            />
          </a>
          <p className="t-label c-muted text-[10px]">BeeBoosted.com</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
